import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Package, ShoppingCart, ClipboardList, Plus, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    total_products: 0,
    active_products: 0,
    pending_orders: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${API_URL}/api/admin/dashboard/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      title: 'Total Products',
      value: stats.total_products,
      icon: Package,
      color: 'blue',
      iconBg: 'bg-blue-100'
    },
    {
      title: 'Active Products',
      value: stats.active_products,
      icon: ShoppingCart,
      color: 'green',
      iconBg: 'bg-green-100'
    },
    {
      title: 'Pending Orders',
      value: stats.pending_orders,
      icon: ClipboardList,
      color: 'yellow',
      iconBg: 'bg-yellow-100'
    }
  ];

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-600 text-sm font-medium mb-2">{stat.title}</p>
                    <p className="text-4xl font-bold text-gray-900">{loading ? '...' : stat.value}</p>
                  </div>
                  <div className={`${stat.iconBg} p-4 rounded-lg`}>
                    <Icon className={`w-8 h-8 text-${stat.color}-600`} />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Button
            onClick={() => navigate('/admin/products/new')}
            className="bg-blue-500 hover:bg-blue-600 text-white py-8 text-lg font-semibold"
          >
            <Plus className="w-5 h-5 mr-2" />
            Add New Product
          </Button>
          <Button
            onClick={() => navigate('/admin/products')}
            variant="outline"
            className="border-2 border-gray-900 text-gray-900 py-8 text-lg font-semibold hover:bg-gray-50"
          >
            <Eye className="w-5 h-5 mr-2" />
            View All Products
          </Button>
          <Button
            onClick={() => navigate('/admin/custom-orders')}
            variant="outline"
            className="border-2 border-gray-900 text-gray-900 py-8 text-lg font-semibold hover:bg-gray-50"
          >
            <ClipboardList className="w-5 h-5 mr-2" />
            View Custom Orders
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
